import { render, staticRenderFns } from "./StockCheckNew.vue?vue&type=template&id=6f5c8943&"
import script from "./StockCheckNew.vue?vue&type=script&lang=ts&"
export * from "./StockCheckNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports